/* src/modules/discounts/api.js */

import gql from 'graphql-tag';

const SEASON_FRAGMENT = gql`
  fragment SeasonFragment on Season {
    _id
    startDate {
      timestamp
    }
    endDate {
      timestamp
    }
  }
`;

const DISCOUNT_FRAGMENT = gql`
  fragment DiscountFragment on Discount {
    _id
    active
    body
    usedBy {
      _id
    }
    season {
      ...SeasonFragment
    }
  }
  ${SEASON_FRAGMENT}
`;

const DISCOUNT_HOLDER_FRAGMENT = gql`
  fragment DiscountHolderFragment on DiscountHolder {
    _id
    name
    email
    phone
    universities {
      _id
      shortName
      name
    }
    discounts {
      ...DiscountFragment
    }
    organization {
      _id
      name
    }
  }
  ${DISCOUNT_FRAGMENT}
`;

export const FETCH_DISCOUNT_HOLDERS_QUERY = gql`
  query fetchDiscountHolders($discountHolderSearchInput: DiscountHolderSearchInput!) {
    discountHolders(input: $discountHolderSearchInput) {
      ...DiscountHolderFragment
    }
  }
  ${DISCOUNT_HOLDER_FRAGMENT}
`;

export const FETCH_SEASONS_QUERY = gql`
  query fetchSeasons($seasonSearchInput: SeasonSearchInput!) {
    seasons(input: $seasonSearchInput) {
      ...SeasonFragment
    }
  }
  ${SEASON_FRAGMENT}
`;

export const CREATE_SEASON_MUTATION = gql`
  mutation createSeason($seasonInput: SeasonInput!) {
    addSeason(input: $seasonInput) {
      ...SeasonFragment
    }
  }
  ${SEASON_FRAGMENT}
`;

export const CREATE_DISCOUNT_HOLDER_MUTATION = gql`
  mutation createDiscountHolder($discountHolderInput: DiscountHolderInput!) {
    addDiscountHolder(input: $discountHolderInput) {
      ...DiscountHolderFragment
    }
  }
  ${DISCOUNT_HOLDER_FRAGMENT}
`;

export const CREATE_DISCOUNT_MUTATION = gql`
  mutation createDiscount($discountInput: DiscountInput!) {
    addDiscount(input: $discountInput) {
      ...DiscountFragment
    }
  }
  ${DISCOUNT_FRAGMENT}
`;

export const MODIFY_ACTIVE_DISCOUNT_MUTATION = gql`
  mutation modifyActiveDiscount($discount: ID!, $active: Boolean!) {
    modifyActiveDiscount(_discount: $discount, active: $active) {
      ...DiscountFragment
    }
  }
  ${DISCOUNT_FRAGMENT}
`;

export const MODIFY_DISCOUNT_HOLDER_MUTATION = gql`
  mutation modifyDiscountHolder($discountHolderUpdateInput: DiscountHolderUpdateInput!) {
    modifyDiscountHolder(input: $discountHolderUpdateInput) {
      ...DiscountHolderFragment
    }
  }
  ${DISCOUNT_HOLDER_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./src/modules/discounts/api.js